import { render } from "./LearnChoice.vue?vue&type=template&id=22c5f574&scoped=true"
import script from "./LearnChoice.vue?vue&type=script&lang=js"
export * from "./LearnChoice.vue?vue&type=script&lang=js"

import "./LearnChoice.vue?vue&type=style&index=0&id=22c5f574&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c5f574"]])

export default __exports__